// extracted by mini-css-extract-plugin
module.exports = {"commentInputArea":"index-module__commentInputArea___2JZMs","commentSubmit":"index-module__commentSubmit___M8A76"};